import React from 'react'
import { BrandPlanIntegrations } from 'types'
import { Text } from 'blaze-ui/Text/Text'
import { Blogpost } from 'blaze-ui/icons/24'
import { HighDetailedMail } from 'blaze-ui/icons/40'
import { SwitchPlatformMenu } from '../SwitchPlatformMenu'
import Styles from './TacticIntegration.module.scss'
import cx from 'classnames'

interface GenericIntegrationProps {
  index: number
  isHighlighted?: boolean
  tactic: BrandPlanIntegrations
}

export const GenericIntegration: React.FC<GenericIntegrationProps> = ({ index, tactic }) => {
  if (tactic !== 'seo' && tactic !== 'email') {
    return <></>
  }

  return (
    <div className={cx(Styles.tacticIntegration)}>
      <Text variant="smallList">
        <div className={Styles.indexIndicator}>{index} </div>
      </Text>

      <div className={Styles.tacticIcon}>
        {tactic === 'seo' ? <Blogpost size={35} /> : <HighDetailedMail size={35} />}
      </div>

      <div className={Styles.tacticName}>
        <Text variant="largeList">Using another platform</Text>
        <Text variant="secondary" color="var(--dark-40)">
          Generate content only
        </Text>
      </div>

      <SwitchPlatformMenu tactic={tactic} />
    </div>
  )
}
